module.exports = __webpack_public_path__ + "static/media/chat.a22a1110.mp3";